import { createComponent } from '../core/create-component.js';
import 'react';
import 'tiny-warning';
const ButtonSuperBreak = createComponent({
  root: 'br',
  displayName: 'ButtonSuperBreak',
  propConfig: {
    classNames: ['swan-button-super-break']
  }
});
export { ButtonSuperBreak };